import { useTranslation } from 'react-i18next';

const SCHEDULE_COUNT = 5;
const scheduleIndices = Array.from({ length: SCHEDULE_COUNT }, (_, i) => i);

export default function DailySchedule() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[800px] mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          {String(t('coursesAdvanced.schedule.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesAdvanced.schedule.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('coursesAdvanced.schedule.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed">{__s}</p>))}
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Gold Line */}
          <div className="absolute left-[19px] top-0 bottom-0 w-[1px] bg-gradient-to-b from-accent-500/40 via-accent-500/20 to-accent-500/40 hidden sm:block"></div>

          <div className="space-y-0">
            {scheduleIndices.map((index) => {
              const description = t(`coursesAdvanced.schedule.${index}.description`);
              return (
                <div key={index} className="flex gap-6 pb-10 last:pb-0">
                  {/* Time Circle */}
                  <div className="hidden sm:flex flex-col items-center flex-shrink-0 relative z-10">
                    <div className="w-[39px] h-[39px] rounded-full border border-accent-500/40 bg-background-100 flex items-center justify-center">
                      <span className="w-2 h-2 rounded-full bg-accent-500/60"></span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 pt-1">
                    <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-4 mb-3">
                      <span className="text-[14px] text-accent-600 tracking-[0.08em] font-medium whitespace-nowrap font-label">
                        {t(`coursesAdvanced.schedule.${index}.time`)}
                      </span>
                      <h4 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em]">
                        {t(`coursesAdvanced.schedule.${index}.title`)}
                      </h4>
                    </div>
                    {description && (
                      <p className="text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em]">
                        {description}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Note */}
        {String(t('coursesAdvanced.schedule.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.04em] mt-8 text-center">{__s}</p>))}
      </div>
    </section>
  );
}
